import StandardLink from "../../tools/StandardLink";

export default function DemoDescription({ demo }) {

  return (
    <div className="demo-description">

      <h2>{demo.id}</h2>

      <p>
        {demo.description}
      </p>
      
      {demo.link && (<p><StandardLink href={demo.link} isNewWindow={true}>
        Learn more
      </StandardLink></p>)}
      
    </div>
  );
}